import { MFAData } from '@fanduel/cpe-um-bundle/account/contract';
import { SliceErrorState } from '@/store/slices/sliceError';
import { SessionJWT } from '@/utilities/getters/types';
import type { RegionCode } from '@/utilities/constants/regions';

/** Derived from the `REGIONS` allow-list so the two cannot drift apart. */
export type Region = RegionCode;

export enum UserSessionStoreParts {
  userSessionContext = 'userSessionContext',
  sessionError = 'sessionError',
}

export type UserSessionContext = {
  created: Date | null;
  authToken?: SessionJWT | null;
  loginToken?: SessionJWT | null;
  hasActiveSession: boolean;
  userId: string | null;
  sessionId: string | null;
  region: Lowercase<Region> | null;
  sessionStartTime: Date | null;
  mfa: MFAData | null;
  /** Tracks that connectivity was lost; used to trigger a reload on reconnect. */
  wasOnline: boolean;
  /** Timezone reported by the server-time response. */
  timezone: string | null;
};

export type UserSessionErrorPayload = Partial<SliceErrorState>;
export type UserSessionContextPayload = Partial<UserSessionContext>;

export type SessionSlice = {
  /** Increments whenever session slice parts are reset (logout / session clear). */
  sessionResetRevision: number;
  userSessionContext: UserSessionContext;
  userSessionError: SliceErrorState;
  setUserSessionContext: (newState: UserSessionContextPayload) => void;
  setUserSessionError: (newState: UserSessionErrorPayload) => void;
  resetUserSessionPart: (part: UserSessionStoreParts) => void;
  resetAllUserSessionParts: () => void;
};
